module.exports = __webpack_public_path__ + "img/smallPopXIcon.1f5a7fef.svg";